import { useEffect, useRef, useState, useCallback } from 'react';

import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Slider = ({ container_width = null, starting_index = 0, children }) => {
  const SliderContainer = useRef(null);

  const [sliderState, setSliderState] = useState();
  const [prevButtonDisabled, setPrevButtonDisabled] = useState(true);
  const [nextButtonDisabled, setNextButtonDisabled] = useState(false);

  const handleSlider = useCallback((s_index) => {
    if (SliderContainer.current) {
      const carousel = SliderContainer.current;
      let maxWidth =
        carousel.children.length * carousel.children.item(0)?.offsetWidth;

      //Get margins as offsetWidth only includes padding, border and content
      let margin_left = parseInt(getComputedStyle(carousel.children.item(0)).getPropertyValue("margin-left").replace('px', ''));
      let margin_right = parseInt(getComputedStyle(carousel.children.item(0)).getPropertyValue("margin-right").replace('px', ''));

      setSliderState({
        ...sliderState,
        width_carosel: carousel.offsetWidth,
        qnt_childrens: carousel.children.length,
        width_childrens: carousel.children.item(0)?.offsetWidth + (margin_left + margin_right),
        max_width_carousel: maxWidth,
      });

      if( s_index > 0 ) {
        let child_width = carousel.children.item(0)?.offsetWidth + (margin_left + margin_right);
        SliderContainer.current.scrollLeft = (child_width * s_index) - ((carousel.offsetWidth - (child_width + (margin_left + margin_right))) / 2) //have to add margins on again otherwise can't centre properly
      }
    }
  }, [setSliderState]);

  const handleSliderAction = (e, action) => {
    e.preventDefault();
    let containerWidth = SliderContainer.current.offsetWidth;
    let containerContentWidth = SliderContainer.current.scrollWidth;

    switch (action) {
      case 'next': {
        let newNextVal = (SliderContainer.current.scrollLeft +=
          sliderState?.width_childrens);
        if (newNextVal > 0) {
          setPrevButtonDisabled(false);
        }

        if (newNextVal + containerWidth >= containerContentWidth) {
          setNextButtonDisabled(true);
        }
        return newNextVal;
      }
      case 'prev': {
        let newPrevVal = (SliderContainer.current.scrollLeft -=
          sliderState?.width_childrens);
        if (newPrevVal <= 15 || SliderContainer.current.scrollLeft <= 15) {
          setPrevButtonDisabled(true);
        }

        if (newPrevVal + containerWidth < containerContentWidth) {
          setNextButtonDisabled(false);
        }

        return newPrevVal;
      }
      default: {
        return null;
      }
    }
  };

  useEffect(() => {
    //Init slider only if children exist
    if( children.length > 0 ) {
      handleSlider(starting_index);
    }
  }, [children]);

  useEffect(() => {
    SliderContainer.current.addEventListener('scroll', function () {
      let containerWidth = SliderContainer.current.offsetWidth;
      let containerContentWidth = SliderContainer.current.scrollWidth;
      let scrollLeft = SliderContainer.current.scrollLeft;

      if (scrollLeft + containerWidth >= containerContentWidth) {
        setNextButtonDisabled(true);
      }

      if (scrollLeft + containerWidth < containerContentWidth) {
        setNextButtonDisabled(false);
      }

      if (scrollLeft <= 15) {
        setPrevButtonDisabled(true);
      }

      if (scrollLeft > 15) {
        setPrevButtonDisabled(false);
      }
    });
  }, []);

  return (
    <div className="slider" style={{ maxWidth: `${container_width}px` }}>
      <div className="slider__container" ref={SliderContainer}>
        {children}
      </div>
      <div className="buttons">
        <button
          onClick={(e) => {handleSliderAction(e,'prev')}}
          id="prev"
          className={`prev ${prevButtonDisabled === true ? 'disabled' : ''}`}
        >
          <FontAwesomeIcon icon={faChevronLeft} size="1x" />
        </button>
        <button
          onClick={(e) => {handleSliderAction(e,'next')}}
          id="next"
          className={`next ${nextButtonDisabled === true ? 'disabled' : ''}`}
        >
          <FontAwesomeIcon icon={faChevronRight} size="1x" />
        </button>
      </div>
    </div>
  );
};

export default Slider;
